<app-header></app-header>
<app-menu></app-menu>
<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12" style="top: 87px">
  <mat-tab-group
    mat-align-tabs="center"
    [selectedIndex]="selected.value"
    (selectedIndexChange)="selected.setValue($event)"
  >
    <mat-tab label="Search" [disabled]="tab === 0">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12" [formGroup]="searchForm">
        <h3 class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12" style="text-align: center">
          Scan Pick Ticket or PO# to start the order.
        </h3>
        <mat-form-field appearance="fill" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
          <mat-label>Barcode</mat-label>
          <input matInput placeholder="Barcode" formControlName="serach" />
        </mat-form-field>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row">
          <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
            <button
              mat-stroked-button
              color="primary"
              class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
              style="background: darkblue; color: white"
              (click)="openDialogSearch()"
            >
              Scanner
            </button>
          </div>
          <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
            <button
              mat-stroked-button
              color="primary"
              class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
              style="background: darkblue; color: white"
              (click)="OnSearch()"
            >
              Search
            </button>
          </div>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Add items" [disabled]="tab === 1" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row">
       <div class="col-xs-5 col-sm-5 col-md-5 col-lg-5 col-xl-5 col-xxl-5 row">

        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
          <mat-card class="example-card col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
            <mat-card-header>
              <mat-card-title>Order info</mat-card-title>
              <button
                      mat-stroked-button
                      (click)="OnCancel()"
                      color="primary"
                      class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
                      style="background: darkblue; color: white"
                    >
                      cancel
                    </button>
            </mat-card-header>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12" style="text-align: center;height: 100px;">
              <img
                mat-card-image
                src="../../../assets/3plfs.png"
                alt="Photo of a Shiba Inu"
                style="width: 50%"
              />
            </div>
            <mat-card-content>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12" [formGroup]="FormAdd">
                <h3 class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12" style="text-align: center">Add Items</h3>
                <mat-form-field appearance="fill" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                  <mat-label>Barcode</mat-label>
                  <input matInput placeholder="Barcode" formControlName="add" />
                </mat-form-field>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row">
                  <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                    <button
                      mat-stroked-button
                      (click)="openDialog()"
                      color="primary"
                      class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
                      style="background: darkblue; color: white"
                    >
                      Scanner
                    </button>
                  </div>
                  <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                    <button
                      mat-stroked-button
                      color="primary"
                      class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
                      style="background: darkblue; color: white"
                      (click)="OnResultadoLector()"
                    >
                      Add
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12" *ngFor="let item of datosSearch">
                <p>OrderId: {{ item.OrderId }}</p>
                <p>PONumber: {{ item.PONumber }}</p>
                <p>RefNumber:{{ item.RefNumber }}</p>
                <p>ShipDate: {{ item.ShipDate }}</p>
                <p>CancelShipDate: {{ item.CancelShipDate }}</p>
                <p>Notes: {{ item.Notes }}</p>
                <p>Status: {{ item.Status }}</p>
              </div>
            </div>
              
            </mat-card-content>
            <mat-card-actions> </mat-card-actions>
          </mat-card>
        </div>

       </div>
       <div class="col-xs-7 col-sm-7 col-md-7 col-lg-7 col-xl-7 col-xxl-7 row">
         <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
          <mat-form-field class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
            <mat-label>Search</mat-label>
            <input
              matInput
              (keyup)="applyFilter($event)"
              placeholder="Search"
              #input
            />
          </mat-form-field>
      
          <div class="mat-elevation-z8 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"  >
            <table mat-table [dataSource]="dataSource" matSort #TableViewSort="matSort" > 
              <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedColumns">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{column}} </th>
                <td mat-cell *matCellDef="let element"> {{element[column]}} </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
             
         
            </table>
      
            <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"  #TableViewPaginator="matPaginator"></mat-paginator>
          </div>
         </div>
         <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
          <mat-form-field class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
            <mat-label>Search</mat-label>
            <input
              matInput
              (keyup)="applyFilter2($event)"
              placeholder="Search"
              #input2
            />
          </mat-form-field>
      
          <div class="mat-elevation-z8 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"  >
            <table mat-table [dataSource]="dataSourceadd" matSort #TableViewSortadd="matSort" > 
              <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedColumns">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{column}} </th>
                <td mat-cell *matCellDef="let element"> {{element[column]}} </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumnsAdd"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumnsAdd;"></tr>
             
         
            </table>
      
            <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"  #TableViewPaginatoradd="matPaginator"></mat-paginator>
          </div>
         </div>
       </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
